import { TOGGLE_GRID } from '.'

export default () => ({ type: TOGGLE_GRID })



// WEBPACK FOOTER //
// ./src/store/actions/toggleGrid.js